import { cn } from "@/lib/utils";

export default function Close_Clock({ className }: { className?: string }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="currentColor" className={cn("size-6", className)}>
			<path
				d="M16 2.66666C8.64802 2.66666 2.66669 8.64799 2.66669 16C2.66669 23.352 8.64802 29.3333 16 29.3333C23.352 29.3333 29.3334 23.352 29.3334 16C29.3334 8.64799 23.352 2.66666 16 2.66666ZM16 26.6667C10.1187 26.6667 5.33335 21.8813 5.33335 16C5.33335 10.1187 10.1187 5.33332 16 5.33332C21.8814 5.33332 26.6667 10.1187 26.6667 16C26.6667 21.8813 21.8814 26.6667 16 26.6667Z"
				fill="inherit"
			/>
			<path d="M17.3334 9.33332H14.6667V16.552L19.0574 20.9427L20.9427 19.0573L17.3334 15.448V9.33332Z" fill="inherit" />
		</svg>
	);
}
